import React from 'react';

class Navigator extends React.Component {

    constructor(props) {
        
        super(props);

        this.state = {
            cameraNormal: 0
        }

        this.currentNavigator = React.createRef();
    }

    componentWillUpdate() {

        if(!this.currentNavigator.current || !this.props.cam) return;

        let cameraNormal = this.props.cam.state.currentCameraNormal.toFixed(4);
        
        //hotfix: increase normal 5% for time view, so the last known year equals the end of the path
        if(this.props.view.path === '/time/') cameraNormal *= 1.05;
        
        if(cameraNormal < 0) cameraNormal = 0;
        if(cameraNormal > 1) cameraNormal = 1;
        if(cameraNormal === this.state.cameraNormal) return;
        this.setState({cameraNormal});

        const currentNav = this.currentNavigator.current;
        const totalLength = currentNav.path.current.getTotalLength();
        const point = currentNav.path.current.getPointAtLength(cameraNormal * totalLength);

        currentNav.marker.current.setAttribute('transform', `translate(${point.x} ${point.y})`);

        //color and artist view: hide all labels but the closest (requires the data-normal attribute)
        if(this.props.view.path === '/color/' || this.props.view.path === '/artist-list/') {

            const textNodeNormals = currentNav.svg.current.querySelectorAll('text[data-normal]');

            [].map.call(textNodeNormals, node => {

                let opacity = 1 - Math.abs(cameraNormal - parseFloat(node.dataset.normal))*5;
                if(opacity < 0) opacity = 0;
                if(opacity > 1) opacity = 1;
                node.style.opacity = opacity*0.8;
            });

        }

    }

    render() {

        if(!this.props.view) return null;

        return (
            <div className="navigator">
                {this.props.view.path === '/color/'       && <NavigatorColor ref={this.currentNavigator} />}
                {this.props.view.path === '/time/'        && <NavigatorTime ref={this.currentNavigator} currentYear={this.props.view.currentYear} />}
                {this.props.view.path === '/artist-list/' && <NavigatorArtistList ref={this.currentNavigator} />}
            </div>
        )
    }
}



class NavigatorColor extends React.Component {

    constructor(props) {
        super(props);
        this.path = React.createRef();
        this.marker = React.createRef();
        this.svg = React.createRef();
    }

    render() {

        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 363 206" ref={this.svg}>
                <g ref={this.marker}>
                    <circle className="navigator-circle" cx="0" cy="0" r="8.5"/>
                </g>
                <path ref={this.path} className="navigator-path" d="M10,197c-.06-21.56,27.94-21.64,27.88-43.2s-28.07-21.48-28.13-43S37.69,89.15,37.63,67.59,9.56,46.1,9.5,24.54"/>

                <text className="navigator-text" data-normal="1.000" transform="translate(28.42 28.74)">violett</text>
                <text className="navigator-text" data-normal="0.892" transform="translate(38.92 47.24)">blau</text>
                <text className="navigator-text" data-normal="0.780" transform="translate(54.92 64.24)">grün</text>
                <text className="navigator-text" data-normal="0.643" transform="translate(46.92 89.74)">gelb</text>
                <text className="navigator-text" data-normal="0.550" transform="translate(32.42 102.74)">orange</text>
                <text className="navigator-text" data-normal="0.445" transform="translate(31.42 125.24)">rot</text>
                <text className="navigator-text" data-normal="0.292" transform="translate(53.42 146.74)">braun</text>
                <text className="navigator-text" data-normal="0.217" transform="translate(55.92 163.74)">schwarz</text>

            </svg>
        )
    }
}


class NavigatorTime extends React.Component {

    constructor(props) {
        super(props);
        this.path = React.createRef();
        this.marker = React.createRef();
    }

    render() {

        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 363 206">
                <text className="navigator-text-merri" transform="translate(0.92 197.56)">1904</text>
                <text className="navigator-text-merri" transform="translate(199.92 117.56)">1988</text>
                <line ref={this.path} className="navigator-path" x1="41.5" y1="183" x2="185.5" y2="122" />
                <g ref={this.marker} transform="translate(41.52 182.98)">
                    <text className="navigator-text-merri" transform="translate(10.92 21.56)">{this.props.currentYear}</text>
                    <circle className="navigator-circle" cx="0" cy="0" r="8.5" />
                </g>
            </svg>
        )
    }
}


class NavigatorArtistList extends React.Component {

    constructor(props) {
        super(props);
        this.svg = React.createRef();
        this.path = React.createRef();
        this.marker = React.createRef();
    }

    render() {

        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 363 206" ref={this.svg}>
                <line ref={this.path} className="navigator-path" x1="24" y1="197" x2="23.5" y2="24.5"/>
                <g ref={this.marker} transform="translate(23.5 92.5)">
                    <circle className="navigator-circle" r="8.5"/>
                </g>
                
                <text className="navigator-text" data-normal="1.000" transform="translate(42.42 29)">FRANZ MARC</text>
                <text className="navigator-text" data-normal="0.835" transform="translate(42.42 58)">VERSCHIEDENE</text>
                <text className="navigator-text" data-normal="0.696" transform="translate(42.42 82)">PAUL KLEE</text>
                <text className="navigator-text" data-normal="0.575" transform="translate(42.42 101)">ERICH HECKEL</text>
                <text className="navigator-text" data-normal="0.495" transform="translate(42.42 116)">WASSILY KANDINSKY</text>
                <text className="navigator-text" data-normal="0.403" transform="translate(42.42 130)">GABRIELE MÜNTER</text>
                <text className="navigator-text" data-normal="0.320" transform="translate(42.42 144)">ERNST LUDWIG KIRCHNER</text>
                <text className="navigator-text" data-normal="0.235" transform="translate(42.42 158)">OTTO MUELLER</text>
                <text className="navigator-text" data-normal="0.155" transform="translate(42.42 172)">EL LISSITZKY</text>
                <text className="navigator-text" data-normal="0.081" transform="translate(42.42 186)">ELSE LASKER-SCHÜLER</text>
                <text className="navigator-text" data-normal="0.000" transform="translate(42.42 200)">HENRI MATISSE</text>
            </svg>
        )
    }
}


export default Navigator